export default "__VITE_ASSET__CJXDpe3x__"